import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { PanelsPage } from './pages/PanelsPage.js';
import { PartylinesPage } from './pages/PartylinesPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { ExternalsPage } from './pages/ExternalsPage.js';
import { MonitorPage } from './pages/MonitorPage.js';
import { useConfigBootstrap } from './hooks/use-config.js';
import { useLiveStateStore } from './store/live-state-store.js';

export function App(): JSX.Element {
  const { error } = useConfigBootstrap();
  const bindLiveState = useLiveStateStore((s) => s.bind);

  useEffect(() => bindLiveState(), [bindLiveState]);

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line no-console
      console.error('Config-Bootstrap fehlgeschlagen:', error);
    }
  }, [error]);

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/panels" element={<PanelsPage />} />
        <Route path="/partylines" element={<PartylinesPage />} />
        <Route path="/externals" element={<ExternalsPage />} />
        <Route path="/monitor" element={<MonitorPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}
